import { Navigate } from 'react-router-dom';
import AuthHeader from '@/app/templates/auth-header';
import Login from '@/features/auth/login/login';
import SignUpPage from '@/features/signup/sign-up';
import { ErrorComponent, ForgotPassword, Marketing, ShopifyNewSubscriptionPlans, ShopifyLoginV2, ShopifyOTP, ShopifyRegistration, AcceptInvitation, SignUp, OTPVerification, Payment, PaymentVerifying, SignUpOTP, SignUpCompany, SignUpContinue, SignUpPlans, SignUpPayment, SignUpPaymentVerifying, SignUpResumeError } from './public-route-pages';
import { LegacySignupRedirect, ShopifySubscriptionCompleteRedirect } from './legacy-redirects';

export const publicRoutes = [
  {
    element: <AuthHeader />,
    children: [
      {
        path: 'shopify/subscription-plans',
        element: <ShopifyNewSubscriptionPlans />,
      },
      {
        path: 'shopify/subscription-complete',
        element: <ShopifySubscriptionCompleteRedirect />,
      },
      {
        path: 'forgot-password',
        element: <ForgotPassword />,
      },
      {
        path: 'v2/shopify/sign-up',
        element: <ShopifyRegistration />,
      },
      {
        path: 'v2/shopify/otp',
        element: <ShopifyOTP />,
      },
      {
        path: 'v2/login',
        element: <ShopifyLoginV2 />,
      },
      {
        path: 'accept-invite',
        element: <AcceptInvitation />,
      },
      {
        path: 'marketing',
        element: <Marketing />,
      },
      // Stripe signup flow routes (legacy)
      {
        path: 'signup-legacy',
        element: <SignUp />,
      },
      {
        path: 'signup-existing-user',
        element: <LegacySignupRedirect />,
      },
      {
        path: 'otp',
        element: <OTPVerification />,
      },
      {
        path: 'plans',
        element: <Navigate to="/account/settings/plans" replace />,
      },
      {
        path: 'payment',
        element: <Payment />,
      },
      {
        path: 'payment/verifying',
        element: <PaymentVerifying />,
      },
      // New signup flow routes
      {
        path: 'signup',
        element: <SignUpPage />,
      },
      {
        path: 'signup/register',
        element: <Navigate to="/signup" replace />,
      },
      {
        path: 'signup/otp',
        element: <SignUpOTP />,
      },
      {
        path: 'signup/company',
        element: <SignUpCompany />,
      },
      {
        path: 'signup/continue',
        element: <SignUpContinue />,
      },
      {
        path: 'signup/plans',
        element: <SignUpPlans />,
      },
      {
        path: 'signup/payment',
        element: <SignUpPayment />,
      },
      {
        path: 'signup/payment/verifying',
        element: <SignUpPaymentVerifying />,
      },
      {
        path: 'signup/resume-error',
        element: <SignUpResumeError />,
      },
      {
        path: 'login',
        element: <Login />,
      },
      {
        path: '',
        element: <Login />,
      },
      {
        path: 'error',
        element: <ErrorComponent />,
      },
      {
        path: '*',
        element: <Navigate to="login" />,
      },
    ],
  },
];
